import type {
  InteractiveContent,
  ScaleResult,
} from '@core-api/presentation/types/response';
import type { ScalesResultForVisualization } from '../types';

export const transformScalesForVisualization = (
  scalesResults: ScaleResult[],
  choices: InteractiveContent['choices'],
): ScalesResultForVisualization[] => {
  return scalesResults.map((result) => {
    const choice = choices.find(
      (choice) =>
        choice.interactiveContentChoiceId === result.interactiveContentChoiceId,
    );

    const score = result.scaleResults.reduce<Record<number, number>>(
      (acc, scaleResult) => {
        acc[scaleResult.value] = scaleResult.responseCount;
        return acc;
      },
      {},
    );

    const identifiedResults = result.scaleResults.map((scaleResult) => ({
      value: scaleResult.value,
      responseCount: scaleResult.responseCount,
      participants: scaleResult.participants,
    }));

    return {
      id: result.interactiveContentChoiceId ?? '',
      label: choice?.title ?? '',
      score,
      skips: result.skips,
      identifiedResults,
    };
  });
};
